import React from 'react';
import { Link } from 'react-router';
import type { LscLeague } from '../types';
import { LscLogo } from './LscLogo';
import LeagueLogo from './LeagueLogo';
import { lscPath } from '../routing';

interface SidebarBrandAreaProps {
  league?: LscLeague | null;
  showLeagueBadge?: boolean;
}

export const SidebarBrandArea: React.FC<SidebarBrandAreaProps> = ({
  league,
  showLeagueBadge = false,
}) => {
  return (
    <div className="p-4 border-b border-secondary-700 max-h-24" data-testid="sidebar-brand-area">
      <div className="flex items-start gap-3" data-testid="sidebar-brand-row">
        <Link
          to={lscPath()}
          className="shrink-0"
          aria-label="League Stream Center home"
          data-testid="stream-center-brand-link"
        >
          <LscLogo variant="nav" />
        </Link>
        {showLeagueBadge && league && (
          <div
            className="flex min-w-0 flex-1 items-center gap-2 pt-0.5"
            data-testid="league-workspace-badge"
          >
            <LeagueLogo league={league} size="badge" testId="league-sidebar-logo" />
            <div className="min-w-0">
              <p className="truncate text-xs font-medium text-white">{league.name}</p>
              <p className="truncate text-[10px] text-secondary-500">League workspace</p>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default SidebarBrandArea;
